import React, { useState } from 'react';
import { motion } from "framer-motion"

export default function Navbar() {
    const [isOpen, setIsOpen] = useState(false);

    const toggleMenu = () => {
        setIsOpen(!isOpen);
    };

    const redirectToBuy = () => {
        window.open('https://app.uniswap.org/swap?outputCurrency=0xB5FeB8Db42F29050e7CD1Afc5A309EbAd91714DA&chain=base')
    };

    return (
            <nav className="font-Londrina text-lg p-8 max-w-screen-xl mx-auto">
                <div className="flex items-center text-white"> 
                    <div className='text-5xl outlined-text justify-left'>
                        BASED PEPE
                    </div>

                    <button onClick={toggleMenu} type="button" className="inline-flex items-center p-2 w-10 h-10 justify-center text-sm text-gray-500 rounded-lg md:hidden hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-gray-200" aria-expanded={isOpen ? "true" : "false"}>
                        <span className="sr-only">Open main menu</span>
                        <svg className="w-5 h-5" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 17 14">
                            <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M1 1h15M1 7h15M1 13h15"/>
                        </svg>
                    </button>
                    
                    <div className={`flex-wrap mx-auto justify-center w-full md:block md:w-auto ${isOpen ? 'block' : 'hidden'}`}>
                        <ul className="flex justify-center flex-col md:flex-row md:space-x-12">
                            <li>
                                <a target="_blank" href="https://www.fiverr.com/ben_duffield" className="hover:text-blue-700">ABOUT</a>
                            </li>
                            <li>
                                <a target="_blank" href="https://app.uniswap.org/explore/tokens/base/0xb5feb8db42f29050e7cd1afc5a309ebad91714da" className="hover:text-blue-700">TOKENOMICS</a>
                            </li>
                            <li>
                                <a target="_blank" href="https://basescan.org/address/0xB5FeB8Db42F29050e7CD1Afc5A309EbAd91714DA" className="hover:text-blue-700">CONTRACT</a>
                            </li>
                            <li>
                                <a target="_blank" href="https://www.fiverr.com/s/3Xoy5V" className="hover:text-blue-700">SERVICES</a>
                            </li>
                        </ul>
                    </div>

                    <motion.button whileHover={{ scale: 1.1 }} whileTap={{ scale: 0.9 }} onClick={redirectToBuy} className='border-2 rounded-lg p-2'>
                        BUY ON UNISWAP
                    </motion.button>
                </div>
            </nav>
    );
}